// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import PartnerService from 'services/PartnerService';

// Components
import Loader from 'components/common/Loader';
import EditPartnerModal from 'components/admin/partners/EditPartnerModal';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class PartnersPage extends React.Component {

    constructor(props) {
        super(props);

        this.editPartnerModalRef = React.createRef();

        this.requestID = 1;
        this.state = {
            isLoading: true
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        GlobalStateService.setValues({
            area: 'partners'
        });
        const partners = await PartnerService.list();
        this.setState({
            partners,
            isLoading: false
        });
    }

    async editPartner(partner) {
        await this.editPartnerModalRef.current.show({
            partnerID: partner.id
        });
        this.load();
    }

    async addPartner() {
        await this.editPartnerModalRef.current.show({
        });
        this.load();
    }

    render() {
        return (<>
            <div className="page partners-page">

                <PageHeader>
                    <h1>Partners</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addPartner()}>
                            <span className="fa-solid fa-plus"></span>{' '}
                            New partner
                        </button>

                    </div>

                </PageHeader>

                <main>

                    <Container>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditPartnerModal ref={this.editPartnerModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            partners
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (

            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable partners-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {partners.map(p =>
                            <tr key={p.id} onClick={e => this.editPartner(p)}>
                                <td>{p.name}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>

        );
    }
}

export default withRouter(PartnersPage);